import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { DataSidebar, SidebarItem } from "./data";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import AvatarUploader from "@/shared/components/common/avatar";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { Drawer } from "@mui/material";
/**
 * HamburgerMenu
 *
 * کامپوننت منوی همبرگری (Drawer) برای نمایش ناوبری در حالت موبایل یا نمای کوچک:
 * - نمایش آیتم‌های منو و زیرمنوها
 * - مدیریت وضعیت آیتم فعال و باز شدن زیرمنوها
 * - تغییر مسیر با استفاده از react-router
 * - امکان خروج از حساب کاربری با پاک کردن توکن‌ها و localStorage
 *
 * ویژگی‌ها:
 * - Drawer باز شونده از بالا با MUI
 * - استفاده از AvatarUploader برای نمایش آواتار کاربر
 * - پشتیبانی از RTL
 * - انیمیشن smooth هنگام باز و بسته شدن زیرمنوها
 *
 * Props:
 * @param setOpenDrawer (function) – تغییر وضعیت باز/بسته بودن Drawer
 * @param openDrawer (boolean) – وضعیت فعلی Drawer
 *
 * استفاده:
 * @returns JSX.Element
 */

const HamburgerMenu = ({setOpenDrawer,openDrawer,}: {setOpenDrawer: any;openDrawer: boolean;}) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null);
  const [openParentId, setOpenParentId] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    DataSidebar.forEach((item) => {
      if (item.path === location.pathname) {
        setActiveItemId(item.id);
        setOpenParentId(null);
      }
      item.children?.forEach((child) => {
        if (child.path === location.pathname) {
          setActiveItemId(child.id);
          setOpenParentId(item.id);
        }
      });
    });
  }, [location.pathname]);

  const handleClick = (item: SidebarItem) => {
    if (item.children && item.children.length > 0) {
      setOpenParentId((prev) => (prev === item.id ? null : item.id));
    } else {
      setActiveItemId(item.id);
      navigate(item.path);
      setOpenDrawer(false);
    }
  };

  const handleLogout = () => {
     localStorage.removeItem("userPhone");
      localStorage.removeItem("ID");
      localStorage.removeItem("newrole");
      localStorage.removeItem("roleEnter");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenbest");
      localStorage.removeItem("refreshToken");

    navigate("/login");
  };

  return (
    <Drawer
      anchor="top"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      PaperProps={{sx: {height: "100vh",bgcolor: "transparent",color: "#fff",padding: 2,direction: "rtl",width: 300,},}}>
      <BoxKit>
        {openDrawer && (
          <BoxKit
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              bottom:0,
              bgcolor: "#0B0B0B",
              color: "#F3F3F3",
              padding: "20px",
              zIndex: 998,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
              overflowY: "auto",
              maxHeight: "100vh",
              width: 300,
            }}
          >
            {/* Avatar + Name */}
            <StackKit direction="column" alignItems="center" mb={2}>
              <AvatarUploader />
              <TypoGraphyKit variant="subtitle2">نام کاربر</TypoGraphyKit>
            </StackKit>

            {/* Menu List */}
            <StackKit direction="column" gap={1}>
              {DataSidebar.map((item) => (
                <BoxKit key={item.id}>
                  <BoxKit
                    onClick={() => handleClick(item)}
                    sx={{
                      padding: "10px",
                      backgroundColor: activeItemId === item.id || openParentId === item.id ? "#7367F0" : "transparent",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <StackKit direction="row" alignItems="center" gap={1}>
                      {item.icon}
                      <TypoGraphyKit>{item.title}</TypoGraphyKit>
                    </StackKit>
                  </BoxKit>

                  {/* Children */}
                  {item.children && openParentId === item.id && (
                    <StackKit direction="column" pl={3} mt={1}>
                      {item.children.map((child) => (
                        <BoxKit
                          key={child.id}
                          onClick={() => { setActiveItemId(child.id); setOpenDrawer(false); navigate(child.path);}}
                          sx={{
                            padding: "6px 10px",
                            color: activeItemId === child.id ? "#7367F0" : "#ccc",
                            cursor: "pointer",
                            fontSize: "14px",
                            borderRadius: "4px",
                          }}
                        >
                          {child.title}
                        </BoxKit>
                      ))}
                    </StackKit>
                  )}
                </BoxKit>
              ))}
            </StackKit>

            {/* Logout */}
            <BoxKit mt={4} onClick={handleLogout} sx={{cursor: "pointer",color: "red",display: "flex",alignItems: "center",gap: 1,}}>
              <LoginOutlinedIcon />
              <span>خروج</span>
            </BoxKit>
          </BoxKit>
        )}
      </BoxKit>
    </Drawer>
  );
};

export default HamburgerMenu;
